// ============================================================
// /src/ui/components/UploadTrigger.tsx (DUMB UI - ZERO LOGIC)
// ============================================================

import React, { useRef } from "react";

interface UploadTriggerProps {
  onFileSelect: (file: File) => void;
  disabled: boolean;
}

export const UploadTrigger: React.FC<UploadTriggerProps> = ({ 
  onFileSelect, 
  disabled 
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="w-full">
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        multiple={false}
        onChange={(e) => e.target.files?.[0] && onFileSelect(e.target.files[0])}
        className="hidden"
        aria-label="Wybierz zdjęcie z aparatu lub galerii"
      />
      
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        disabled={disabled}
        className="w-full min-h-[60px] bg-[#1a1a1a] border-2 border-dashed border-[#333] 
                   text-white font-mono text-sm uppercase tracking-wider
                   hover:border-[#00e676] hover:text-[#00e676]
                   focus:ring-2 focus:ring-[#00e676] focus:outline-none
                   disabled:opacity-50 disabled:cursor-not-allowed
                   rounded-none transition-colors"
        aria-busy={disabled}
      >
        {disabled ? "ANALIZA..." : "ZDJĘCIE (APARAT LUB GALERIA)"}
      </button>
    </div>
  );
};
